import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { localizeDate as _localizeDate } from '../../../../utils/vuex';
import debounce from 'lodash/debounce';
import listMixin from '../../listMixin';
var defaultItemsPerPage = 10;
export default {
  name: 'NiotaClassicDevicesAddItemSelector',
  mixins: [listMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: ''
    },
    fireflyOriginatorsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'start'
      }, {
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.table.name'),
        value: 'title',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.form.description'),
        value: 'title',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt',
        align: 'start'
      }],
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      accountIds: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    headers: function headers() {
      return this.getHeaders();
    }
  }),
  watch: {
    accountIds: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList(true);
    }, 500)
  },
  methods: {
    rowStyle: function rowStyle(item) {
      if (this.type === 'originator' && this.fireflyOriginatorsOnly) {
        if (item.datasource.type !== 'firefly' && item.datasource.type !== 'firefly_mqtt') {
          return 'opacity: 0.5';
        }
      }

      return '';
    },
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var promise = undefined;
      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;

      if (this.type === 'originator') {
        if (!this.accountIds.length) {
          promise = NiotaClassicApiService.originatorsFetch((this.searchItem || '').trim(), usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.originatorsFetchByAccount((this.searchItem || '').trim(), this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }

      if (this.type === 'application') {
        if (this.searchItem && this.searchItem.trim() !== '') {
          promise = NiotaClassicApiService.applicationsFind((this.searchItem || '').trim(), this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          if (!this.accountIds.length) {
            promise = NiotaClassicApiService.applicationsFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
          } else {
            promise = NiotaClassicApiService.applicationsFetchByAccount(this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
          }
        }
      }

      promise.then(function (res) {
        if (_this.type === 'originator') {
          _this.list = res.data.originators;
          _this.serverItemsLength = res.pagination.itemCount;
        }

        if (_this.type === 'application') {
          if (res.data.applications) {
            _this.list = res.data.applications;
          }

          if (res.data.application) {
            _this.list = res.data.application;
          }

          _this.serverItemsLength = res.pagination.itemCount;
        }
      }).catch(function (error) {
        if (_this.type === 'originator') {
          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
        }

        if (_this.type === 'application') {
          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
        }

        console.error('Error fetching originators', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    localizeDate: function localizeDate(item) {
      return _localizeDate(item);
    },
    getHeaders: function getHeaders() {
      if (this.type === 'originator') {
        this.tableHeaders.splice(2, 0, {
          text: this.$i18n_t('NiotaClassic.Devices.type'),
          value: 'createdAt',
          align: 'start'
        });
      }

      return this.tableHeaders;
    },
    handleClickRow: function handleClickRow(item) {
      if (this.type === 'originator' && this.fireflyOriginatorsOnly) {
        if (item.datasource.type !== 'firefly' && item.datasource.type !== 'firefly_mqtt') {
          return false;
        }
      }

      this.$emit('item-selected', item);
      this.resetFilter();
    },
    resetFilter: function resetFilter() {
      this.accountIds = [];
    },
    goBack: function goBack() {
      this.resetFilter();
      this.$emit('reset-application');
    },
    closeDialog: function closeDialog() {
      this.$emit('close');
      this.resetFilter();
    }
  }
};